import React, { useRef } from "react";

export default function PurchaseZplButton({ labelData }) {
  /*   All States
   ********************************************* */
  const iframeRef = useRef(null);

  /*   All Functions
   ********************************************* */
  const generateZplCode = () => {
    if (!labelData || labelData.length === 0) return "";

    // Label dimensions - 4"x2"
    const labelWidth = 812; // 4 inches at 203 DPI
    const labelHeight = 406; // 2 inches at 203 DPI

    // Font size - same for all rows based on image
    const fontSize = { height: 40, width: 34 };

    // Y positions for rows based on the image spacing
    const rowPositions = [30, 90, 150, 210, 270, 330];

    // Calculate positions for the three parts of each row
    const columnNamePosition = 30; // Left margin for column names
    const columnNameWidth = 150; // Width for column names (adjust based on longest name)
    const colonPosition = 210; // Position for colons
    const valuePosition = 250; // Position for values start

    // Generate ZPL code for each row
    let zplElements = "";

    // Only use up to 6 rows of data
    const rowsToUse = labelData.slice(0, 6);

    // Fill with empty rows if less than 6 provided
    while (rowsToUse.length < 6) {
      rowsToUse.push({ row: rowsToUse.length + 1, column: "", value: "" });
    }

    for (let i = 0; i < 6; i++) {
      const rowData = rowsToUse[i];
      const yPosition = rowPositions[i];

      // Column name (left-aligned)
      zplElements += `^FO${columnNamePosition},${yPosition}^A0,${
        fontSize.height
      },${fontSize.width}^FD${rowData.column || ""}^FS\n      `;

      // Colon (centered)
      zplElements += `^FO${colonPosition},${yPosition}^A0,${fontSize.height},${fontSize.width}^FD:^FS\n      `;

      // Value (left-aligned, starting after colon)
      zplElements += `^FO${valuePosition},${yPosition}^A0,${fontSize.height},${
        fontSize.width
      }^FD${rowData.value || ""}^FS\n      `;
    }

    return `
      ^XA
      ^PW${labelWidth}^LL${labelHeight}    ^FX Set label size to 4"x2" (203dpi: 812x406 dots)
      
      ${zplElements}
      ^XZ
    `;
  };

  const printLabel = () => {
    if (!labelData || labelData.length === 0) return;

    if (iframeRef.current) {
      const iframe = iframeRef.current;
      const doc = iframe.contentWindow || iframe.contentDocument;
      if (doc.document) {
        doc.document.open();

        // Start HTML document
        doc.document.write(`
          <html>
            <body>
        `);

        // Generate and add ZPL code
        const zplCode = generateZplCode();
        doc.document.write(`<pre>${zplCode}</pre>`);

        // Close HTML document
        doc.document.write(`
            </body>
          </html>
        `);

        doc.document.close();
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      }
    }
  };

  /*   All UseEffects
   ********************************************* */

  return (
    <>
      <button
        onClick={printLabel}
        className="btn btn-info btn-sm"
        disabled={!labelData || labelData.length === 0}
      >
        ZPL
      </button>

      {/* Hidden iframe for printing */}
      <iframe
        ref={iframeRef}
        style={{ display: "none" }}
        title="ZPL Print Frame"
      ></iframe>
    </>
  );
}
